import React from 'react';
import {
  FormControl,
  Theme,
  TextareaAutosize,
  TextareaAutosizeProps,
} from '@material-ui/core';
import { withStyles, WithStyles, createStyles } from '@material-ui/core/styles';
import clsx from 'clsx';
import { Typography } from '../Typography';

const styles = (theme: Theme) => {
  return createStyles({
    root: {
      width: '100%',
      margin: theme.spacing(2, 0),
      '& textarea': {
        padding: '10px 0.5rem !important',
        borderColor: 'rgba(0, 0, 0, 0.23)',
        opacity: 38,
        '&:hover': {
          borderColor: 'rgba(0, 0, 0, 0.23)',
          opacity: 38,
        },
      },
    },
    helperText: {
      margin: theme.spacing(1, 2),
    },
  });
};

export interface ITextArea
  extends WithStyles<TextareaAutosizeProps & typeof styles> {
  id?: string;
  onChange?: React.ChangeEventHandler<HTMLTextAreaElement>;
  placeholder?: string;
  value?: string | ReadonlyArray<string> | number;
  label?: React.ReactNode;
  helperText?: React.ReactNode;
  error?: boolean;
  disabled?: boolean;
  required?: boolean;
  maxRows?: number | string;
  minRows?: number | string;
  customStyles?: any;
}

export const TextArea: React.FC<ITextArea> = ({
  classes,
  id,
  label,
  placeholder,
  value,
  onChange,
  customStyles,
  helperText,
  error = false,
  disabled = false,
  required = false,
  maxRows = 20,
  minRows = 10,
}: ITextArea) => {
  return (
    <FormControl
      id={id}
      className={clsx(classes.root, customStyles && customStyles)}
    >
      {label && <Typography variant="body2">{label}</Typography>}
      <TextareaAutosize
        id="TextareaAutosize"
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        disabled={disabled}
        required={required}
        maxRows={maxRows}
        minRows={minRows}
      />
      <Typography variant="body2" color="error" className={classes.helperText}>
        {error && helperText}
      </Typography>
    </FormControl>
  );
};

export default withStyles(styles)(TextArea);
